module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0004"
    }
  }, [_vm._v("The Kowloon Cafe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tulips")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mansions of Federico Juarez")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Japanese Baseball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Indestructible Hadrian Wilks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First and Last Annual Six Towns Area Old-Timers’ Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lime Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arbiter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fred Noonan Flying Services")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wavelengths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underestimating Lynn Johanssen")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71add91c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0002.vue
// module id = 66
// module chunks = 0